import { doc, getDoc } from "firebase/firestore";
import { getApiFunctions } from "../api";
import { getRefs } from "../draft/ref";

export const generateQRCode = ({ id }, callback) => {
  const functions = getApiFunctions().client.clientDepositBailiffQRGenerate;
  const options = { id };
  functions(options)
    .then((res) => {
      console.log(res);
      const data = res?.data;
      callback && callback({ status: 200, data });
    })
    .catch((err) => {
      console.error(err);
      callback &&
        callback({ status: 500, data: err?.message || "Invalid error" });
    });
};

export const getDialogByBailiff =
  ({ bailiff, slot }, callback) =>
  (dispatch) => {
    const cRef = getRefs().dialog;
    const id = `${bailiff}-${slot}`;
    const dRef = doc(cRef, id);
    getDoc(dRef)
      .then((snapshot) => {
        if (snapshot) {
          const data = snapshot?.data();
          callback && callback({ status: 200, data });
        } else {
          callback && callback({ status: 500, data: "Invalid error" });
        }
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Invalid error" });
      });
  };
